import { LuExternalLink } from 'react-icons/lu';
import { getPortalIcon } from '../utils/iconUtils';

const isDarkButton = (hex) => {
  const color = (hex || '').toLowerCase();
  return color === '#000' || color === '#000000' || color === 'black';
};

const SocialLinkCard = ({ link }) => {
  const Icon = getPortalIcon(link.icon || 'LuGlobe');
  const brandColor = link.brandColor || '#3b82f6';
  const darkBtn = isDarkButton(brandColor);

  return (
    <div className="rounded-xl border border-gray-200 dark:border-dark-600 overflow-hidden">
      <div
        className="p-4 border-b border-gray-200 dark:border-dark-600"
        style={{ backgroundColor: `${brandColor}18` }}
      >
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
            style={{ backgroundColor: brandColor }}
          >
            <Icon className={`w-5 h-5 ${darkBtn ? 'text-white dark:text-black' : 'text-white'}`} />
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-dark-800 dark:text-white truncate">{link.title}</h3>
            {link.subtitle && (
              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{link.subtitle}</p>
            )}
          </div>
        </div>
      </div>
      <div className="p-4">
        {link.description && (
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">{link.description}</p>
        )}
        {link.url && (
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              darkBtn
                ? 'bg-black dark:bg-white text-white dark:text-black hover:bg-gray-800 dark:hover:bg-gray-100'
                : 'text-white hover:opacity-90'
            }`}
            style={darkBtn ? undefined : { backgroundColor: brandColor }}
          >
            <Icon className="w-4 h-4" />
            {link.buttonText || 'Visit'}
            <LuExternalLink className="w-3 h-3" />
          </a>
        )}
      </div>
    </div>
  );
};

export default SocialLinkCard;
